import React from 'react';
import { Send, Zap, Trash2, RefreshCw, Settings } from 'lucide-react';
import { Button } from '../../ui';

interface ActionBarProps {
  onSend: () => void;
  onHandshake: () => void;
  onClearStorage?: () => void;
  disabledSend: boolean;
  isLoading: boolean;
  skipCache: boolean;
  onToggleSkipCache: (enabled: boolean) => void;
}

export function ActionBar({ onSend, onHandshake, onClearStorage, disabledSend, isLoading, skipCache, onToggleSkipCache }: ActionBarProps) {
  return (
    <div className="px-3 py-2.5 border-t border-navy-700/30 bg-navy-800/30 space-y-2.5">
      {/* Ações Principais */}
      <div className="flex gap-2 items-center flex-wrap">
        <Button
          variant="success"
          size="xs"
          onClick={onSend}
          disabled={disabledSend}
          loading={isLoading}
          icon={Send}
          title="Enviar ação (Ctrl+Enter)"
          className="flex-1 sm:flex-none min-w-[90px]"
        >
          {isLoading ? 'Enviando...' : 'Enviar'}
        </Button>

        <Button
          variant="primary"
          size="xs"
          onClick={onHandshake}
          icon={Zap}
          title="Forçar handshake de sessão com o CorelDraw"
          className="flex-1 sm:flex-none"
        >
          <span>Sync</span>
        </Button>

        {/* Separador visual */}
        <div className="hidden sm:block w-px h-6 bg-navy-600/50 mx-0.5" />

        {/* Utilitários */}
        {onClearStorage && (
          <Button
            variant="danger"
            size="xs"
            onClick={onClearStorage}
            icon={Trash2}
            title="Limpar todo o localStorage e sessionStorage (debugging)"
            className="flex-1 sm:flex-none"
          >
            <span className="hidden sm:inline">Limpar Storage</span>
            <span className="sm:hidden">Limpar</span>
          </Button>
        )}
      </div>

      {/* Configurações */}
      <div className="flex items-center gap-2 pt-2 border-t border-navy-700/20">
        <div className="flex items-center gap-1.5 text-[10px] text-gray-400">
          <Settings className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Config:</span>
        </div>
        <label className="flex items-center gap-1.5 cursor-pointer group flex-1 sm:flex-none">
          <input
            type="checkbox"
            checked={skipCache}
            onChange={(e) => onToggleSkipCache(e.target.checked)}
            className="w-3.5 h-3.5 rounded border-navy-600 bg-navy-800 text-primary-500 focus:ring-2 focus:ring-primary-500 focus:ring-offset-1 focus:ring-offset-navy-800 cursor-pointer"
            title="Sempre usar código fresco da API/arquivo (Ctrl+/)"
          />
          <span className="text-[10px] text-gray-300 group-hover:text-white transition-colors flex items-center gap-1">
            <RefreshCw className={`w-3 h-3 ${skipCache ? 'text-primary-400 animate-spin-slow' : 'text-gray-500'}`} />
            <span className="hidden sm:inline">Sempre usar código fresco</span>
            <span className="sm:hidden">Código fresco</span>
          </span>
        </label>
      </div>

      {/* Indicador quando skipCache está ativo */}
      {skipCache && (
        <div className="text-[10px] text-blue-200 flex items-center gap-1.5 bg-blue-500/10 px-2 py-1 rounded border border-blue-500/30">
          <RefreshCw className="w-3 h-3 animate-spin-slow text-blue-300" />
          <span className="flex-1">Modo ativo: código sempre será buscado da API/arquivo, ignorando cache</span>
        </div>
      )}
    </div>
  );
}


